import { ReactComponent as Star } from "./star.svg";

export default {
    Star,
};
